import { render } from "./AcceptPage.vue?vue&type=template&id=08bb283a&ts=true"
import script from "./AcceptPage?vue&type=script&lang=ts"
export * from "./AcceptPage?vue&type=script&lang=ts"

import "@/views/_assets/_verticalApp.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__